<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>App Settings</h2>
  </div>

  <div class="container">
    <div class="left-container">

      <!-- Active year -->
      <form [formGroup]="form">
        <section class="section-container nrg-border-radius">
          <div class="section-header">
            <span>Active Year</span>
            <button mat-raised-button color="primary" type="button" (click)="onSubmit()" [disabled]="form.invalid || isUnchanged">
              <mat-icon>save</mat-icon>
              Save
            </button>
          </div>
          <div class="section-content">
            <p class="description">
              Sets the active business year used across the application.
            </p>
            <div class="form-field-container">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Active year</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="activeYear"
                  placeholder="e.g. 2025"
                  [min]="initialYear ?? 1900"
                  max="2100"
                  required
                />
                <mat-hint *ngIf="initialYear !== null">
                  Active year can only move forward (current: {{ initialYear }}).
                </mat-hint>
                <mat-error *ngIf="form.get('activeYear')?.hasError('required')">
                  Active year is required
                </mat-error>
                <mat-error *ngIf="form.get('activeYear')?.hasError('backwards')">
                  Active year cannot be earlier than the current year ({{ initialYear }})
                </mat-error>
                <mat-error *ngIf="form.get('activeYear')?.hasError('min') && !form.get('activeYear')?.hasError('backwards') || form.get('activeYear')?.hasError('max')">
                  Year must be between 1900 and 2100
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </section>
      </form>

      <!-- Login attempt cleanup -->
      <form [formGroup]="cleanupForm">
        <section class="section-container nrg-border-radius">
          <div class="section-header">
            <span>Login Attempt Cleanup</span>
            <button mat-raised-button color="primary" type="button" (click)="saveCleanupSettings()" [disabled]="cleanupForm.invalid || cleanupForm.pristine">
              <mat-icon>save</mat-icon>
              Save
            </button>
          </div>
          <div class="section-content">
            <p class="description">
              Periodically deletes old rows from the login attempts log. Runs once a day at the
              configured UTC hour and removes attempts older than the retention window.
            </p>

            <mat-slide-toggle formControlName="enabled" class="toggle-field">
              Enable scheduled cleanup
            </mat-slide-toggle>

            <div class="form-field-container">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Retention (days)</mat-label>
                <input matInput type="number" formControlName="retentionDays" min="1" max="3650" required />
                <mat-hint>Attempts older than this many days are deleted.</mat-hint>
                <mat-error *ngIf="cleanupForm.get('retentionDays')?.hasError('required')">
                  Retention days is required
                </mat-error>
                <mat-error *ngIf="cleanupForm.get('retentionDays')?.hasError('min') || cleanupForm.get('retentionDays')?.hasError('max')">
                  Retention must be between 1 and 3650 days
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-field-container">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Run hour (UTC)</mat-label>
                <input matInput type="number" formControlName="hourUtc" min="0" max="23" required />
                <mat-hint>Hour of day (0–23, UTC) the cleanup runs.</mat-hint>
                <mat-error *ngIf="cleanupForm.get('hourUtc')?.hasError('required')">
                  Run hour is required
                </mat-error>
                <mat-error *ngIf="cleanupForm.get('hourUtc')?.hasError('min') || cleanupForm.get('hourUtc')?.hasError('max')">
                  Hour must be between 0 and 23
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </section>
      </form>

      <!-- Customer report rebuild -->
      <form [formGroup]="rebuildForm">
        <section class="section-container nrg-border-radius">
          <div class="section-header">
            <span>Customer Report Rebuild</span>
            <button mat-raised-button color="primary" type="button" (click)="saveRebuildSettings()" [disabled]="rebuildForm.invalid || rebuildForm.pristine">
              <mat-icon>save</mat-icon>
              Save
            </button>
          </div>
          <div class="section-content">
            <p class="description">
              Controls the nightly rebuild of the precalculated customer-report table. Runs once a day
              at the configured UTC hour. Manual rebuilds from Control Panel work regardless of this toggle.
            </p>

            <mat-slide-toggle formControlName="enabled" class="toggle-field">
              Enable scheduled rebuild
            </mat-slide-toggle>

            <div class="form-field-container">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Run hour (UTC)</mat-label>
                <input matInput type="number" formControlName="hourUtc" min="0" max="23" required />
                <mat-hint>Hour of day (0–23, UTC) the rebuild runs.</mat-hint>
                <mat-error *ngIf="rebuildForm.get('hourUtc')?.hasError('required')">
                  Run hour is required
                </mat-error>
                <mat-error *ngIf="rebuildForm.get('hourUtc')?.hasError('min') || rebuildForm.get('hourUtc')?.hasError('max')">
                  Hour must be between 0 and 23
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-field-container">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Batch size</mat-label>
                <input matInput type="number" formControlName="batchSize" min="1" max="5000" required />
                <mat-hint>Companies processed per resolver pass.</mat-hint>
                <mat-error *ngIf="rebuildForm.get('batchSize')?.hasError('required')">
                  Batch size is required
                </mat-error>
                <mat-error *ngIf="rebuildForm.get('batchSize')?.hasError('min') || rebuildForm.get('batchSize')?.hasError('max')">
                  Batch size must be between 1 and 5000
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </section>
      </form>

    </div>
  </div>
</div>
